// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"pageWrap-cdd647","error404":"error404-cdd647"};